import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Icon,
  IconButton,
  Button
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { BackdropCircular } from 'components';
import {
  getAffiliatesBannerSlidesApi,
  deleteAffiliatesBannerSlideApi,
  getFullfilmentBannerSlidesApi,
  deleteFullfilmentBannerSlideApi,
  getBrands
} from 'api';
import EditBannerSlide from './BannerSlideModal';


const options = {
  filterArrayFullMatch: false,
  responsive: 'standard',
  selectableRows: 'none',
  search: false,
  filter: false,
  download: false,
  print: false,
  pagination: true,
  viewColumns: false,
  elevation: 0,
  rowsPerPage: 20,
  rowsPerPageOptions: [20, 40, 80, 100]
};

const BannerSlides = () => {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState();
  const [editableSlideData, setEditableSlideData] = useState(null);

  const {brandsData, loading: loadingBrands} = useSelector((state) => state.brands);
  const {profile} = useSelector((state) => state.user);
  const permissions = profile?.config?.permissions || {};

  useEffect(() => {
    getAffiliatesBannerSlidesApi({dispatch});
    getFullfilmentBannerSlidesApi({dispatch});

    if (brandsData) {
      getBrands({dispatch});
    }
  }, []);

  const handleChangeActive = (id) => {
    setExpanded(expanded !== id ? id : null);
  };

  const handleDeleteAffiliateSlide = (id) => {
    deleteAffiliatesBannerSlideApi({dispatch, id});
  };

  const handleDeleteFullfilmentSlide = (id) => {
    deleteFullfilmentBannerSlideApi({dispatch, id});
  };

  const {
    affiliatesSlides,
    loadingAffiliatesSlides,
    fullfilmentSlides,
    loadingFullfilmentSlides
  } = useSelector((state) => state.partners);

  const loading = loadingAffiliatesSlides || loadingFullfilmentSlides || loadingBrands;

  const affiliateColumns = [
    {
      name: 'image',
      label: 'Slide',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const {image, brandName} = affiliatesSlides[dataIndex];

          return (
            <img src={image} alt={brandName} className="max-w-full" />
          );
        }
      }
    },
    {
      name: 'urlType',
      label: 'Banner for',
    },
    {
      name: '',
      label: '',
      options: {
        setCellHeaderProps: () => ({className: 'w-200'}),
        customBodyRenderLite: (dataIndex) => {
          const {_id} = affiliatesSlides[dataIndex];
          return (
            <>
              {permissions?.adminBannerSlidesRemove &&
              <IconButton
                onClick={() => handleDeleteAffiliateSlide(_id)}
              >
                <Icon>delete</Icon>
              </IconButton>}
              {permissions?.adminBannerSlidesEdit &&
              <IconButton
                onClick={() => {
                  setEditableSlideData({...affiliatesSlides[dataIndex], slideType: 'Affiliate'});
                }}
              >
                <Icon>edit</Icon>
              </IconButton>}
            </>
          );
        }
      }
    }
  ];

  const fullfilmentColumns = [
    {
      name: 'image',
      label: 'Slide',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const {image, brandName} = fullfilmentSlides[dataIndex];

          return (
            <img src={image} alt={brandName} className="max-w-full" />
          );
        }
      }
    },
    {
      name: 'urlType',
      label: 'Banner for',
    },
    {
      name: '',
      label: '',
      options: {
        setCellHeaderProps: () => ({className: 'w-200'}),
        customBodyRenderLite: (dataIndex) => {
          const {_id} = fullfilmentSlides[dataIndex];
          return (
            <>
              <IconButton
                onClick={() => handleDeleteFullfilmentSlide(_id)}
              >
                <Icon>delete</Icon>
              </IconButton>
              <IconButton
                onClick={() => {
                  setEditableSlideData({...fullfilmentSlides[dataIndex], slideType: 'Direct Fulfillment'});
                }}
              >
                <Icon>edit</Icon>
              </IconButton>
            </>
          );
        }
      }
    }
  ];

  return (
    <div>
      {permissions?.adminBannerSlidesAdd &&
      <Button
        color="primary"
        variant="contained"
        onClick={() => setEditableSlideData({ image: '', urlType: 'brand', slideType: 'Direct Fulfillment' })}
        className="mb-8"
      >
        <Icon className="mr-2">add</Icon>
        <span>Add New Slide</span>
      </Button>}
      <div>
        <Accordion expanded={expanded === 1} onChange={() => handleChangeActive(1)}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} >
            <Typography variant="h5">Fullfilment Slides {`(${fullfilmentSlides.length})`}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {!!fullfilmentSlides.length &&
              <MUIDataTable
                data={fullfilmentSlides}
                columns={fullfilmentColumns}
                options={options}
              />
            }
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={expanded === 2} onChange={() => handleChangeActive(2)}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} >
            <Typography variant="h5">Affiliates Slides {`(${affiliatesSlides.length})`}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {!!affiliatesSlides.length &&
              <MUIDataTable
                data={affiliatesSlides}
                columns={affiliateColumns}
                options={options}
              />
            }
          </AccordionDetails>
        </Accordion>
        {editableSlideData &&
          <EditBannerSlide
            setOpen={setEditableSlideData}
            slideData={editableSlideData}
          />
        }
        <BackdropCircular loading={loading} />
      </div>
    </div>
  );
};

export default BannerSlides;
